/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

// Minimal z-index theme replacement
export const zIndex = {
  behindContent: -1,
  default: 1,
  dropdown: 100,
  tooltip: 200,
  overlay: 999,
  header: 1000,
  modal: 1100,
  popup: 1200,
  blackbox: 9999,
};
